import React from 'react';
import PropTypes from 'prop-types';

import {FormattedNumber, FormattedPlural, FormattedMessage} from 'react-intl';
import { getDisplayResource } from '../../helpers/resource';

const ResourceValue = ({resource, displayUnit, displayLimit, displayValue}) => {
  const displayResource = getDisplayResource(resource);
  const value = (displayLimit && !displayValue) 
    ? displayResource.limit 
    : displayResource.value;
  return (
    <span >
      {displayValue
      && (
        <FormattedNumber value={displayResource.value} maximumFractionDigits={1} />
      )
      }
      {displayLimit 
      && (
        <span>
          {displayValue && " / "}
          <FormattedNumber value={displayResource.limit} maximumFractionDigits={1} />
        </span>
      )
      }
      {displayUnit 
      && (
        <span>
          {" "}
          <FormattedPlural
            value={value === 0 ? 1 : value}
            one={
              <FormattedMessage 
                id={'resource.unit.'+displayResource.unit}
                defaultMessage={displayResource.unit}
              />
            }
            other={
              <FormattedMessage 
                id={'resource.unit.'+displayResource.unit+'.plural'}
                defaultMessage={displayResource.unit+'s'}
              />
            }
          />
        </span>
        )
      } 
    </span>
  );
}

ResourceValue.propTypes = {
  resource: PropTypes.object.isRequired,
  displayUnit: PropTypes.bool,
  displayLimit: PropTypes.bool,
  displayValue: PropTypes.bool,
};

export default ResourceValue;


// WEBPACK FOOTER //
// ./src/components/resources/ResourceValue.js